/* eslint-disable no-restricted-syntax */
import { ChatOpenAI, ChatOpenAICompletions } from '@langchain/openai';
import type { ChatOpenAIFields } from '@langchain/openai';

/**
 * LangChain's streaming-handler path (used by LangGraph's `messages` stream mode)
 * keeps `finish_reason` only in `generationInfo`, never on `message.response_metadata`.
 * The turn guard reads it from the message, so this copies it onto the message.
 */
class FinishReasonCompletions extends ChatOpenAICompletions {
  async* _streamResponseChunks(...args: Parameters<ChatOpenAICompletions['_streamResponseChunks']>) {
    for await (const chunk of super._streamResponseChunks(...args)) {
      const finishReason = chunk.generationInfo?.finish_reason;
      if (typeof finishReason === 'string' && finishReason !== '') {
        chunk.message.response_metadata = { ...chunk.message.response_metadata, finish_reason: finishReason };
      }
      yield chunk;
    }
  }
}

/**
 * Builds a streaming ChatOpenAI whose finish_reason survives into message.response_metadata.
 * The completions instance is passed through `fields`, so it survives `withConfig` / `bindTools`.
 */
export const createStreamingChatOpenAI = (fields: ChatOpenAIFields): ChatOpenAI => new ChatOpenAI({
  ...fields,
  completions: new FinishReasonCompletions(fields),
});
